import theme from './theme';
import AppThemes from './AppThemes';

export default theme;
export { AppThemes };